const BusinessUnit = {
  BusinessUnits: "BusinessUnit.BusinessUnits",
  BusinessUnitInformation: "BusinessUnit.BusinessUnitInformation",
  CreateBusinessUnit: "BusinessUnit.CreateBusinessUnit",
  NewBusinessUnit: "BusinessUnit.NewBusinessUnit",
  SearchBusinessUnit: "BusinessUnit.SearchBusinessUnit",
  BusinessUnitName: "BusinessUnit.BusinessUnitName",
  Manager: "BusinessUnit.Manager",
  NumberOfMembers: "BusinessUnit.NumberOfMembers",
  AverageCoverage: "BusinessUnit.AverageCoverage",
  AverageFee: "BusinessUnit.AverageFee",
  Salary: "BusinessUnit.Salary",
  Member: "BusinessUnit.Member",
  Members: "BusinessUnit.Members",
  CreatedMessage: "BusinessUnit.CreatedMessage",
  SaveBusinessUnit: "BusinessUnit.SaveBusinessUnit",
  ResponsibleManager: "BusinessUnit.ResponsibleManager",
  ResponsibleManagerDescription: "BusinessUnit.ResponsibleManagerDescription",
  BusinessUnitNameDescription: "BusinessUnit.BusinessUnitNameDescription",
  ManagerPermissions: "BusinessUnit.ManagerPermissions",
  SalaryDeviations: "BusinessUnit.SalaryDeviations",
  SalaryDeviationsDescription: "BusinessUnit.SalaryDeviationsDescription",
  HelpTextBusinessUnitName: "BusinessUnit.HelpTextBusinessUnitName",
  HelpTextManager: "BusinessUnit.HelpTextManager",
  HelpTextNumberOfMembers: "BusinessUnit.HelpTextNumberOfMembers",
  HelpTextCompensation: "BusinessUnit.HelpTextCompensation",
  HelpTextAbscence: "BusinessUnit.HelpTextAbscence",
  HelpTextInternalTime: "BusinessUnit.HelpTextInternalTime",
  HelpTextAverageCoverage: "BusinessUnit.HelpTextAverageCoverage",
  HelpTextAverageFee: "BusinessUnit.HelpTextAverageFee",
  HelpTextSalary: "BusinessUnit.HelpTextSalary",
  From: "BusinessUnit.From",
  To: "BusinessUnit.To",
  TimeReportingInterval: "BusinessUnit.TimeReportingInterval",
  IsTimeReportingMandatory: "BusinessUnit.IsTimeReportingMandatory",
  AddMembersDescription: "BusinessUnit.AddMembersDescription",
  EditBusinessUnit: "BusinessUnit.EditBusinessUnit",
  DimensionAlreadyExists: "BusinessUnit.DimensionAlreadyExists",
  Delete: "BusinessUnit.Delete",
  DeleteQuestion: "BusinessUnit.DeleteQuestion",
  Deleted: "BusinessUnit.Deleted",
  DeleteWarning: "BusinessUnit.DeleteWarning",
  SalaryResponsibility: "BusinessUnit.SalaryResponsibility",
  SalaryResponsibilityDescription: "BusinessUnit.SalaryResponsibilityDescription",
  }
export default BusinessUnit;